export const SET_PHONE_LANGUAGE = 'SET_PHONE_LANGUAGE';
export const SET_ENV = 'ENV';
